var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7638 1.7998H17.4102L11.6286 8.40781L18.4302 17.3998H13.1046L8.93344 11.9462L4.16068 17.3998H1.51268L7.69668 10.3318L1.17188 1.7998H6.63268L10.403 6.78461L14.7638 1.7998ZM13.835 15.8158H15.3014L5.83588 3.3006H4.26228L13.835 15.8158Z",
    fill: "#010103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.17a4ad50c2c954df2397005e91d0efd2.svg";
export { ForwardRef as ReactComponent };